import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions } from 'redux-router5';
import { bindActionCreators } from 'redux';

class NavItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.router = context.router;
  }

  render() {
    const {
      className,
      children,
      navigateTo,
      onClick,
      options,
      params,
      routeName,
    } = this.props;
    const href = this.router.buildUrl(routeName, params);
    const handleClick = (evt) => {
      evt.preventDefault();
      if (onClick) {
        onClick(evt);
      }

      navigateTo(routeName, params, options);
    };

    return <a { ...{ href, onClick: handleClick, className } }>{ children }</a>;
  }
}

NavItem.contextTypes = {
  router: PropTypes.object.isRequired,
};

NavItem.defaultProps = {
  children: null,
  className: '',
  onClick: null,
  options: {},
  params: {},
};

NavItem.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  options: PropTypes.shape({}),
  params: PropTypes.shape({}),
  routeName: PropTypes.string.isRequired,

  // functions
  navigateTo: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    navigateTo: actions.navigateTo,
  }, dispatch)
);

export default connect(null, mapDispatchToProps)(NavItem);



// WEBPACK FOOTER //
// ./src/components/Common/NavItem.js